<script>
var token=''

//带token加密 (一般是get请求)
function tddata(obj2){
	 var obj1={};
	 obj1.token=token

	var obj=Object.assign(obj1, obj2);
	var newObj=objKeySort(obj)
	if(obj1.token!=null){
		var d=''
		for(var i in newObj){
			d+=newObj[i]
		}
	   return md5(encodeURIComponent(d+'tuding'))
	}else{
		return false
	}
}
//不带token返回参数（post请求）
function tdNoMd5(obj2){
	var obj1={};
	var obj=Object.assign(obj1, obj2);
	var newObj=objKeySort(obj)
	var d=''
	for(var i in newObj){
		d+=newObj[i]
	}
	return(newObj)
}
//带token返回参数（post请求）
function tdMd5(obj2){
	 var obj1={};
	 obj1.token=token
	var obj=Object.assign(obj1, obj2);
	var newObj=objKeySort(obj)
	if(obj1.token!=null){
		var d=''
		for(var i in newObj){
			d+=newObj[i]
		}
	  return(newObj)
	}else{
		return false
	}
}
//get请求 返回url
function geturl(oobj,url){
  for(var i in oobj){
    if((oobj[i] || oobj[i]===0) && Object.prototype.toString.call(oobj[i])!="[object Array]" ){
      url+='/'+i+'/'+oobj[i]
    }
  }
  return url
}
//a b c升序排序
function objKeySort(obj) {//排序的函数
　　//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
	var newkey = Object.keys(obj).sort();
    var newObj = {};//创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
    }
	return newObj;//返回排好序的新对象
}

// 消息提示封装
// msg消息，type消息类型success,warning
//自定义type类型error（错误提示），normal（正常提示）
function msgAlert(msg,type){
    if(type=='success' || type=='warning'){
        this.$message({
            message: msg,
			type: type
        });
    }else if(type=='error'){
        this.$message.error(msg);
    }else if(type=='normal'){
        this.$message(msg);
    }

}
//2.获取当前时间
function getDateDiff(dateTimeStamp){
	if(!dateTimeStamp){
		return
	}
  	var result;
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;
    var now = new Date().getTime();
    var diffValue = now - dateTimeStamp;
    if(diffValue < 0){
    return;
  }
    var monthC =diffValue/month;
    var weekC =diffValue/(7*day);
    var dayC =diffValue/day;
    var hourC =diffValue/hour;
    var minC =diffValue/minute;
    if(monthC>=1){
    if(monthC<=12)
          result="" + parseInt(monthC) + "个月前";
    else{
      result="" + parseInt(monthC/12) + "年前";
    }
    }
    else if(weekC>=1){
        result="" + parseInt(weekC) + "周前";
    }
    else if(dayC>=1){
        result=""+ parseInt(dayC) +"天前";
    }
    else if(hourC>=1){
        result=""+ parseInt(hourC) +"小时前";
    }
    else if(minC>=1){
        result=""+ parseInt(minC) +"分钟前";
    }else{
    result="刚刚";
  }
    return result;
};
//把标准时间转换成时间('几小时前'...)
function changeTimeStamp(update){
	if(update){
		var reg = new RegExp('"',"g");
		var reg1 = new RegExp('-',"g");
		update=update.replace(reg,"")
		var update1=update.replace(reg1, "/")
		var aa=new Date(update1)
		var time3 =Date.parse(aa);
		time3=getDateDiff(time3)
		return time3
	}
};
// 当前时间 具体到分秒
function writeCurrentDate() {
	var now = new Date();
	var year = now.getFullYear(); //得到年份
	var month = now.getMonth();//得到月份
	var date = now.getDate();//得到日期
	var day = now.getDay();//得到周几
	var hour = now.getHours();//得到小时
	var minu = now.getMinutes();//得到分钟
	var sec = now.getSeconds();//得到秒
	var week;
	month = month + 1;
	if (month < 10) month = "0" + month;
	if (date < 10) date = "0" + date;
	if (hour < 10) hour = "0" + hour;
	if (minu < 10) minu = "0" + minu;
	if (sec < 10) sec = "0" + sec;
	return year + "-" + month + "-" + date  + " " + hour + ":" + minu + ":" + sec;
}
// 计算两个日期之间相差的天数
function   getDifferDays(maxDate, minDate) {
	if (maxDate == null || minDate == null){
		return 0;
	}else{
		var dateStart = new Date(minDate);
		var dateEnd = new Date(maxDate);
		return Math.round(Math.abs(dateEnd - dateStart) / (24 * 60 * 60 * 1000))
	}
}
// 获取cookie
function getCookie(name){
	var strcookie = document.cookie;//获取cookie字符串
	var arrcookie = strcookie.split("; ");//分割
	//遍历匹配
	for ( var i = 0; i < arrcookie.length; i++) {
		var arr = arrcookie[i].split("=");
		if (arr[0] == name){
			return arr[1];
		}
	}
	return "";
}


import ElementUI from 'element-ui';
import md5 from 'js-md5';
import axios from 'axios'
export default {
  token,
  msgAlert,
	tdMd5,
	tdNoMd5,
	tddata,
	objKeySort,
	changeTimeStamp,
	writeCurrentDate,
	getDifferDays,
	getCookie,
  geturl
}
</script>



// WEBPACK FOOTER //
// src/globalDatas.vue